import { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { renderOptions } from '../../../utilsdata';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getOptionsByPath, useNestedDropdownHandler } from '../../../utilsdata';
import { FINANCE, FINANCE_CATEGORYS, FINANCE_MODE_OF_PAYMENT } from '../../../Dropdownmanager';
import { faPen, faTrashCan, faEye } from "@fortawesome/free-solid-svg-icons";
import { setEditHistory } from '../../../Slices/employeeslice';
import { GetAllRecords, setFinanceHistory, softDeleteThunk } from '../../../Slices/financeSlice';
import FinanceWorkHistory from './FinanceWorkHistory';
import { TRANSACTION_MODE, FINANCE_CATEGORY, FINANCE_SUB_CATEGORY } from '../../../databucket';
import { CustomGridTable } from '../../../blueplanitUtils/CustomGridTable';
import { useDispatch, useSelector } from 'react-redux';
import { FilterPanel } from './FinanceFilters';
import { message, Modal, Space, Table } from 'antd';
import { AntdButton, SelectInput } from '../../../blueplanitUtils/InputField';
import { setLoader } from "../../../Slices/loaderSlice";
import dayjs from 'dayjs';
import FinanceActions from './FinanceActions';

const Finance = () => {
  const [filterForm, setFilterState] = useState({
    from: null,
    to: null,
    category: '',
    subCategory: '',
    spentBy: '',
    purchaseDetails: '',
    invoice: '',
    quantity: '',
    amount: '',
    transactionMode: '',
  });
  const [isHistoryVisible, setIsHistoryVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();
  const [visible, setVisible] = useState(false);
  const dispatch = useDispatch();
  const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);
  const categoryoptions = getOptionsByPath(NestedDatabucket, [FINANCE, FINANCE_CATEGORYS]);
  const actionsRef = useRef(null);
  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
  const editHistory = useSelector((state) => state.employee.editHistory);
  const Financedata = useSelector((state) => state?.finance?.AllRecords);
  const options = useSelector((state) => state.dataBucket.databucket);
  const usersList = useSelector((state) => state.employee.AllEmployees);
  const assignToUsers = usersList.filter((user) => user.employeestatus === 'Active');
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 50,
  });
  const [total, setTotal] = useState(0);
  const pageSizeOptions = total <= 50
    ? ['50']
    : total <= 100
      ? ['50', '100']
      : total <= 150
        ? ['50', '100', '150']
        : ['50', '100', '150', '200'];


  const [tableData, setTableData] = useState([]);
  const currentYear = moment().year().toString();
  const currentMonth = moment().month() + 1;
  const years = Array.from({ length: 10 }, (_, i) => moment().year() - i);
  const months = moment.months();

  const [yearFilter, setYearFilter] = useState(String(currentYear));
  const [monthFilter, setMonthFilter] = useState(currentMonth.toString());

  const totalAmount = tableData.reduce((sum, record) => {
    const amount = parseFloat(record.amount) || 0;
    return sum + amount;
  }, 0);

  const getAssignToUsers = (users) =>
    users.map((user, index) => ({
      key: index,
      value: `${user.firstname} ${user.lastname}`,
      label: `${user.firstname} ${user.lastname}`,
    }));

  const handleView = (record) => {
    const reversedHistory = [...record.updateHistory]
      .reverse()
      .map((entry) => ({
        ...entry,
        EditStatus: entry.action === "Created" ? "Created" : "Updated",
        action: entry.action || 'Updated',
      }));

    dispatch(setFinanceHistory(reversedHistory));
    dispatch(setEditHistory(reversedHistory));

    setSelectedRecord({
      date: record?.date,
      category: record?.category,
      subCategory: record?.subCategory,
      purchaseDetails: record?.purchaseDetails,
      invoice: record?.invoice,
      quantity: record?.quantity,
      amount: record?.amount,
      spentBy: record?.spentBy,
      transactionMode: record?.transactionMode,
      remarks: record?.remarks,
      attachments: record?.attachments || [],
      updateHistory: record?.updateHistory || [],
    });

    setIsHistoryVisible(true);
  };

  useEffect(() => {
    (() => {
      if (options) {
        const names = [];
        options.forEach((item) => {
          if (item.department === 'FINANCE_CATEGORY' && item.status === true) {
            names.push(item.name);
          }
        })

      }
    })()
  }, [options]);

  const openAddModal = () => {
    if (actionsRef.current && actionsRef.current.openEdit) actionsRef.current.openEdit(null);
  };

  useEffect(() => {
    const fetchRecords = async () => {
      try {
        dispatch(setLoader(true));

        const year = String(yearFilter);
        const month = String(monthFilter).padStart(2, '0');
        const monthRef = dayjs(`${year}-${month}-01`);
        await dispatch(GetAllRecords({
          page: pagination.current,
          pageSize: pagination.pageSize,
          from: monthRef.startOf('month').toISOString(),
          to: monthRef.endOf('month').toISOString(),
        })).unwrap();
      } catch (err) {
        message.error('Failed to fetch finance records');
      } finally {
        dispatch(setLoader(false));
      }
    };

    fetchRecords();
  }, [yearFilter, monthFilter, pagination.current, pagination.pageSize]);

  useEffect(() => {
    if (!Financedata) return;
    const allRecords = Financedata.records || [];
    const mappedRecords = allRecords
      .filter(r => r.status !== false)
      .map(r => ({
        ...r,
        key: r.id,
        date: r.date,
        attachments: (r.attachments || []).filter(a => a.status !== false),
      }))
      .sort((a, b) => new Date(b.date) - new Date(a.date));

    setTableData(mappedRecords);
    setTotal(Financedata.totalCount || 0);
  }, [Financedata, filterForm]);


  const handleSearch = () => {
    const filtered = Object.fromEntries(
      Object.entries(filterForm).filter(([, v]) => v !== undefined && v !== "" && v !== null)
    );

    const hasRange = filtered.from || filtered.to;

    if (hasRange) {
      dispatch(GetAllRecords({
        ...filtered,
        page: 1,
        pageSize: pagination.pageSize,
      }));
    } else {
      const year = String(yearFilter);
      const month = String(monthFilter).padStart(2, '0');
      const monthRef = dayjs(`${year}-${month}-01`);
      dispatch(GetAllRecords({
        ...filtered,
        page: 1,
        pageSize: pagination.pageSize,
        from: monthRef.startOf('month').toISOString(),
        to: monthRef.endOf('month').toISOString(),
      }));
    }

    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const handleClear = () => {
    setFilterState({
      from: null,
      to: null,
      category: '',
      subCategory: '',
      spentBy: '',
      purchaseDetails: '',
      invoice: '',
      quantity: '',
      amount: '',
      transactionMode: '',
    });

    setYearFilter(String(currentYear));
    setMonthFilter(currentMonth.toString());

    const monthRef = dayjs(`${currentYear}-${String(currentMonth).padStart(2, '0')}-01`);

    dispatch(GetAllRecords({
      page: 1,
      pageSize: pagination.pageSize,
      from: monthRef.startOf('month').toISOString(),
      to: monthRef.endOf('month').toISOString(),
    }));

    setPagination((prev) => ({ ...prev, current: 1 }));
  };



  const handlepageChange = (page, pageSize) => {
    setPagination({ current: page, pageSize });
  };


  const confirmDelete = async (record) => {
    try {
      dispatch(setLoader(true));
      dispatch(softDeleteThunk({
        id: record.id,
        userName: `${loginUser?.firstname} ${loginUser?.lastname}`,
        editedAt: new Date().toISOString(),
      }))

      message.success('Deleted successfully');

      const currentPageCount = tableData.filter(item => item.status !== false).length;
      const isLastItemOnPage = currentPageCount === 1 && pagination.current > 1;
      const newPage = isLastItemOnPage ? pagination.current - 1 : pagination.current;

      setPagination((prev) => ({ ...prev, current: newPage }));
      dispatch(GetAllRecords({ page: newPage, pageSize: pagination.pageSize, ...filterForm }));

    } catch (error) {
      message.error('Failed to delete');
    }
  };

  const refreshRecords = (resetToFirstPage = false) => {
    const page = resetToFirstPage ? 1 : pagination.current;
    const hasRange = filterForm.from || filterForm.to;
    const payload = { page, pageSize: pagination.pageSize, ...filterForm };

    if (!hasRange) {
      const year = String(yearFilter);
      const month = String(monthFilter).padStart(2, '0');
      const monthRef = dayjs(`${year}-${month}-01`);
      payload.from = monthRef.startOf('month').toISOString();
      payload.to = monthRef.endOf('month').toISOString();
    }

    dispatch(GetAllRecords(payload));
    if (resetToFirstPage) setPagination(prev => ({ ...prev, current: 1 }));
  };

  const columns = [
    {
      title: 'S.No',
      key: 'sno',
      dataIndex: 'sno',
      align: 'center',
      width: 70,
      render: (_text, _record, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1
    },
    { title: 'Date', dataIndex: 'date', align: 'center', width: 100, render: (d) => dayjs(d).format('DD/MM/YYYY') },
    { title: 'Category', dataIndex: 'category', align: 'center', width: 120 },
    { title: 'Sub-category', dataIndex: 'subCategory', align: 'center', width: 120 },
    { title: 'Product/Purchase Details', dataIndex: 'purchaseDetails', align: 'center', width: 180 },
    { title: 'Invoice Number', dataIndex: 'invoice', align: 'center', width: 140 },
    { title: 'Quantity', dataIndex: 'quantity', align: 'center', width: 100, sorter: (a, b) => a.quantity - b.quantity },
    { title: 'Amount', dataIndex: 'amount', align: 'center', width: 100, sorter: (a, b) => a.amount - b.amount },
    { title: 'Spent By', dataIndex: 'spentBy', align: 'center', width: 100 },
    { title: 'Mode of Transaction', dataIndex: 'transactionMode', align: 'center', width: 160 },
    { title: 'Remarks', dataIndex: 'remarks', align: 'center', width: 100 },
    {
      title: 'Attachments',
      dataIndex: 'attachments',
      key: 'attachments',
      align: 'center',
      width: 200,
      render: (attachments, row) => {
        const activeAttachments = attachments?.filter(att => att.status === true);
        if (!activeAttachments || activeAttachments.length === 0) return 'No Attachments';
        return (
          <AntdButton label='View' onClick={() => actionsRef.current && actionsRef.current.showAttachmentsModal(activeAttachments, row)} />
        );
      },
    },
    {
      title: 'View',
      dataIndex: 'view',
      align: 'center',
      width: 80,
      render: (_, record) => (
        <FontAwesomeIcon icon={faEye} style={{ color: 'black', cursor: 'pointer' }} onClick={() => handleView(record)} />
      ),
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      align: 'center',
      width: 80,
      render: (_, record) => (
        <Space size="middle">
          <FontAwesomeIcon icon={faPen} style={{ color: '#1890ff', cursor: 'pointer' }} onClick={() => actionsRef.current && actionsRef.current.openEdit(record)} />
          <FontAwesomeIcon icon={faTrashCan}
            style={{ color: 'red', cursor: 'pointer' }}
            onClick={() => {
              Modal.confirm({
                title: 'Are you sure?',
                content: 'Do you really want to delete this record?',
                centered: true,
                okText: 'Yes',
                cancelText: 'No',
                onOk: () => confirmDelete(record),
              });
            }}
          />
        </Space>
      ),
    },
  ];

  const handleExport = (fileFormat, selectedColumns, data) => {
    if (!data || data.length === 0) {
      message.info("No data available for export.");
      return;
    }

    const dataToExport = data.map((row, index) => ({
      ...row,
      sno: (pagination.current - 1) * pagination.pageSize + index + 1,
      date: moment(row.date).format('DD/MM/YYYY'),
    }));

    if (fileFormat === 'CSV') {
      const csvData = convertToCSV(dataToExport, selectedColumns);
      downloadCSV(csvData, 'Finance_Report.csv');
    } else if (fileFormat === 'PDF') {
      simulatePrintDialog(dataToExport, selectedColumns);
    }
  };

  const convertToCSV = (data, selectedColumns) => {
    const headers = selectedColumns.map(getColumnLabel).join(',') + '\n';
    const rows = data.map(row =>
      selectedColumns.map(col => {
        if (col === 'attachments') {
          return `"${(row.attachments && row.attachments.length > 0)
            ? row.attachments.map(f => f.filename || f.data || 'Unnamed').join('; ')
            : 'No Attachments'}"`;
        }
        return `"${row[col] ?? ''}"`;
      }).join(',')
    );
    return headers + rows.join('\n');
  };

  const downloadCSV = (csv, filename) => {
    const blob = new Blob([csv], { type: 'text/csv' });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const simulatePrintDialog = (dataToExport, selectedColumns) => {
    const printableContent = document.createElement("div");
    printableContent.id = "print-content";
    printableContent.style.fontFamily = "Arial, sans-serif";

    const table = document.createElement("table");
    table.style.width = "100%";
    table.style.border = "1px solid #000";
    table.style.borderCollapse = "collapse";

    const thead = document.createElement("thead");
    const headerRow = document.createElement("tr");

    selectedColumns.forEach(col => {
      const th = document.createElement("th");
      th.innerText = getColumnLabel(col);
      th.style.border = "1px solid #000";
      th.style.padding = "5px";
      headerRow.appendChild(th);
    });
    thead.appendChild(headerRow);
    table.appendChild(thead);

    const tbody = document.createElement("tbody");
    dataToExport.forEach(row => {
      const tr = document.createElement("tr");
      selectedColumns.forEach(col => {
        const td = document.createElement("td");

        if (col === 'attachments') {
          td.innerText = (Array.isArray(row.attachments) && row.attachments.length > 0)
            ? row.attachments.map(f => f.filename || f.data || 'Unnamed').join('; ')
            : 'No Attachments';
        } else {
          td.innerText = row[col] || '';
        }

        td.style.border = "1px solid #ccc";
        td.style.padding = "5px";
        tr.appendChild(td);
      });
      tbody.appendChild(tr);
    });

    table.appendChild(tbody);
    printableContent.appendChild(table);

    const style = document.createElement("style");
    style.innerHTML = `
    body * { visibility: hidden; }
    #print-content, #print-content * { visibility: visible; }
    #print-content { position: absolute; top: 0; left: 0; width: 100%; }
  `;
    document.head.appendChild(style);
    document.body.appendChild(printableContent);
    window.print();
    document.body.removeChild(printableContent);
    document.head.removeChild(style);
  };

  const getColumnLabel = (key) => {
    const labels = {
      sno: 'S.No',
      date: 'Date',
      category: 'Category',
      subCategory: 'Sub-category',
      purchaseDetails: 'Product/Purchase Details',
      invoice: 'Invoice Number',
      quantity: 'Quantity',
      amount: 'Amount',
      spentBy: 'Spent By',
      transactionMode: 'Mode of Transaction',
      remarks: 'Remarks',
      attachments: 'Attachments'
    };
    return labels[key] || key;
  };

  const exportColumns = [
    'sno',
    'date',
    'category',
    'subCategory',
    'purchaseDetails',
    'invoice',
    'quantity',
    'amount',
    'spentBy',
    'transactionMode',
    'remarks',
    'attachments'
  ];

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '-20px' }}>
            <SelectInput
              placeholder="Select Year"
              options={years.map(y => ({ value: y, label: y }))}
              value={yearFilter}
              onChange={(val) => setYearFilter(String(val))}
              style={{ width: 120 }}
            />

            <SelectInput
              placeholder="Select Month"
              options={months.map((m, idx) => ({ value: (idx + 1).toString(), label: m }))}
              value={monthFilter}
              onChange={(val) => setMonthFilter(String(val))}
              style={{ width: 140 }}
            />
          </div>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <FinanceActions
              ref={actionsRef}
              handleExport={handleExport}
              exportColumns={exportColumns}
              tableData={tableData}
              categoryoptions={categoryoptions}
              NestedDatabucket={NestedDatabucket}
              FINANCE={FINANCE}
              FINANCE_CATEGORYS={FINANCE_CATEGORYS}
              FINANCE_MODE_OF_PAYMENT={FINANCE_MODE_OF_PAYMENT}
              getAssignToUsers={getAssignToUsers}
              assignToUsers={assignToUsers}
              refreshRecords={refreshRecords}
              onShowFilters={() => setVisible(true)}
            />
          </div>
        </div>

        <div style={{ width: '100%', boxSizing: 'border-box', marginTop: '30px' }}>
          <div className={`row ${visible ? "partial-width" : "full-width"}`}>

            <CustomGridTable
              rowKey='id'
              dataSource={tableData}
              columns={columns}
              Id="FinanceTable"
              scroll={{ x: 'max-content' }}
              bordered
              size="small"
              style={{ fontSize: 12 }}
              pagination={{
                current: pagination.current,
                pageSize: pagination.pageSize,
                total: total,
                onChange: handlepageChange,
                showSizeChanger: true,
                pageSizeOptions: pageSizeOptions,
                showQuickJumper: true,
                showTotal: (total, range) =>
                  `${range[0]}-${range[1]} of ${total} items`,
              }}

              summary={(pageData) => {
                const totalAmount = pageData.reduce((sum, record) => sum + (parseFloat(record.amount) || 0), 0);
                const amountIndex = columns.findIndex(col => col.dataIndex === 'amount');

                return (
                  <Table.Summary.Row style={{ backgroundColor: '#fafafa', fontWeight: 600 }}> {/* light gray background */}
                    {columns.map((col, index) => {
                      if (index === amountIndex) {
                        return (
                          <Table.Summary.Cell
                            key={index}
                            align="center"
                            style={{ fontWeight: 600 }} // bold and blue
                          >
                            Total: {totalAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </Table.Summary.Cell>
                        );
                      }
                      if (index === 4) {
                        return (
                          <Table.Summary.Cell
                            key={index}
                            align="right"
                            style={{ fontWeight: 'bold' }}
                          >
                          </Table.Summary.Cell>
                        );
                      }
                      return <Table.Summary.Cell key={index} />;
                    })}
                  </Table.Summary.Row>
                );
              }}

            />
          </div>

          <FinanceWorkHistory
            open={isHistoryVisible}
            onClose={() => setIsHistoryVisible(false)}
            data={editHistory}
            selectedRecord={selectedRecord}
          />
          <FilterPanel
            filterForm={filterForm}
            handleSearch={handleSearch}
            handleClear={handleClear}
            showModal={openAddModal}
            renderOptions={renderOptions}
            options={options}
            assignToUsers={getAssignToUsers(assignToUsers)}
            FINANCE_CATEGORY={FINANCE_CATEGORY}
            FINANCE_SUB_CATEGORY={FINANCE_SUB_CATEGORY}
            TRANSACTION_MODE={TRANSACTION_MODE}
            visible={visible}
            setVisible={setVisible}
            setFilterState={setFilterState}
          />
        </div>
      </div>

    </div >
  );
};
export default Finance;
